import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { ExpertIntakeForm } from "../components/ExpertIntakeForm";

const STEPS = [
  "Submit public, non-privileged information using the form below.",
  "We run a confidential conflict check and preliminary review.",
  "If there is no conflict, we discuss scope, timing, and fees with counsel.",
  "A signed engagement letter and retainer are put in place before any privileged materials are shared.",
];

const ExpertWitnessIntake = () => (
  <div data-testid="expert-witness-intake-page">
    <PageHero
      kicker="Expert Witness Pre-Retention Intake"
      lines={[<span key="a">Start a confidential</span>, <span key="b">expert <em className="italic text-[#3E9BDC]">inquiry.</em></span>]}
      intro="For counsel evaluating an independent securities or insurance expert — including FINRA arbitration matters. Share public case information below to begin a conflict check and preliminary discussion with American Elm Advisors."
      meta={["FINRA Arbitration", "SEC", "State Regulators", "Insurance"]}
    />

    <section className="py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Kicker>How Retention Works</Kicker>
            <h2 className="mt-5 font-serif font-bold text-2xl sm:text-3xl text-[#0A2B3D] tracking-tight leading-[1.2]">
              A conflict check comes first.
            </h2>
            <p className="mt-5 text-[#475569] leading-relaxed text-sm">
              We take care to protect both sides before any substantive discussion. The steps below
              keep the process clean and preserve independence.
            </p>
          </Reveal>
          <div className="mt-8 space-y-4">
            {STEPS.map((s, i) => (
              <Reveal key={s} delay={i * 0.06}>
                <div className="flex gap-3 items-start" data-testid={`intake-step-${i}`}>
                  <span className="shrink-0 w-6 h-6 rounded-full bg-[#0A2B3D] text-white text-xs flex items-center justify-center font-mono mt-0.5">{i + 1}</span>
                  <p className="text-sm text-[#475569] leading-relaxed">{s}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div className="mt-8 flex items-start gap-3 border-t border-[#0A2B3D]/10 pt-6">
              <Check size={16} className="text-[#3E9BDC] mt-0.5 shrink-0" />
              <p className="text-xs text-[#475569] leading-relaxed">
                Prefer to talk first? <Link to="/expert-witness" data-testid="intake-back-to-ew" className="text-[#3E9BDC] font-semibold hover:underline underline-offset-4">Review our expert witness practice</Link> or
                contact us to arrange a brief, confidential call.
              </p>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7" id="intake-form">
          <ExpertIntakeForm />
        </div>
      </div>
    </section>
  </div>
);

export default ExpertWitnessIntake;
